export default {
      id: "icon--new-calendar-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--new-calendar-usage",
      toString: function () {
        return this.url;
      }
    }